import Vue from 'vue';
import Router from 'vue-router';
import About from '@/components/About';
import Gallery from '@/components/Gallery';
import GalleryEdit from '@/components/GalleryEdit';
import Contact from '@/components/Contact';
import Login from '@/components/Login';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: {
        name: 'About',
      },
    },
    {
      path: '/about',
      name: 'About',
      component: About,
    },
    {
      path: '/gallery',
      name: 'Gallery',
      component: Gallery,
    },
    {
      path: '/edit-gallery',
      name: 'Edit Gallery',
      component: GalleryEdit,
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact,
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
    },
    {
      path: '/*',
      redirect: {
        name: 'About',
      },
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js